import { render, staticRenderFns } from "./LogicPointConfigDialog.vue?vue&type=template&id=cab3ad8a&scoped=true"
import script from "./LogicPointConfigDialog.vue?vue&type=script&lang=js"
export * from "./LogicPointConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./LogicPointConfigDialog.vue?vue&type=style&index=0&id=cab3ad8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab3ad8a",
  null
  
)

export default component.exports